var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRentReportingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9996 19C18.9996 19.55 18.5496 20 17.9996 20H5.99961C5.44961 20 4.99961 19.55 4.99961 19V12H3.29961C2.83961 12 2.62961 11.43 2.96961 11.13L11.3296 3.59997C11.7096 3.25997 12.2896 3.25997 12.6696 3.59997L21.0296 11.13C21.3796 11.43 21.1596 12 20.6996 12H18.9996V19ZM7 10.1916V17.9999H17V10.1917L12 5.68811L7 10.1916Z",
    fill: "#252C35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentReportingIcon);
export default __webpack_public_path__ + "static/media/rent-reporting-icon.571cd5207f9a5f57e59f3d3427cf128e.svg";
export { ForwardRef as ReactComponent };